<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
      />
      <card-component
        class="has-table has-mobile-sort-spaced"
        title="Profesori"
        icon="human-male-board"
      >
        <refresh-button slot="button" />
        <card-toolbar slot="toolbar">
          <div
            slot="left"
            class="buttons has-addons"
          >
            <router-link
              :to="{name:'teacher.new'}"
              class="button is-primary"
            >
              Profesor nou
            </router-link>
          </div>
        </card-toolbar>
        <teachers-table-sample
          v-if="teachers.length > 0"
          :teachers="teachers"
          @handleDeleteTeacher="handleDeleteTeacher"
        />
        <teachers-table-sample
          v-else
          is-empty
        />
      </card-component>
    </section>
  </div>
</template>

<script>

import { reactive } from '@vue/composition-api'
import TeachersTableSample from '@/components/TeachersTableSample.vue'
import CardComponent from '@/components/CardComponent.vue'
import TitleBar from '@/components/TitleBar.vue'
import RefreshButton from '@/components/RefreshButton.vue'
import CardToolbar from '@/components/CardToolbar.vue'
import TeacherService from '@/services/teachers.service'

export default {
  name: 'Teachers',
  components: { CardToolbar, RefreshButton, TitleBar, CardComponent, TeachersTableSample },
  setup (props, { root: { $buefy } }) {
    const titleStack = ['Linguapro', 'Profesori']

    return {
      teachers: reactive([]),
      titleStack,
      isLoading: false
    }
  },
  async created () {
    this.isLoading = true
    this.getAllTeachers().then((response) => {
      this.teachers = response
      this.isLoading = false
    })
  },
  methods: {
    async getAllTeachers () {
      const { getTeachers } = TeacherService
      const response = await getTeachers()
      const { data } = response
      return data
    },
    async handleDeleteTeacher (id) {
      const { deleteTeacher } = TeacherService
      const response = await deleteTeacher(id)
      const { status } = response
      if (status === 200) {
        const index = this.teachers.findIndex((prop) => prop.id === id)
        this.teachers.splice(index, 1)
        this.$buefy.snackbar.open({
          message: 'Inregistrea a fost stearsa.',
          queue: false
        })
      } else {
        this.$buefy.snackbar.open({
          message: 'Eroare la stergerea inregistrarii.',
          queue: false
        })
      }
    }
  }
}
</script>
